import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutHierarchy extends Layout {
    sourceHierarchy: DataSource;
    tableHierarchy: Table;
}
